const en = {
  system: {
    total: "total",
    rm: "remove",
    desc: "No Data",
    cancel: "cancel",
    confirm: "confirm",
    ondel_address_title: "Are you sure you want to delete this address?",
    rules_message: "Please enter",
    message_success: "Success",
    message_warning: "fail",
    myorder: "My Order",
    changePassword: "Change password",
    logout: "logout",
    code: "Confirmation-code",
    yes: "YES",
    no: "NO",
    rm_message: 'This operation will delete the record. Do you want to continue?',
    rm_title: 'Warning',
    rm_ok: 'Confirm',
    rm_cancel: 'Cancel',
    language: 'Language',
    signIn: 'Sign In',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm',
    noOrder: 'No orders yet',
    normalMember: 'Regular user'
  },
  home: {
    title: "Our bestsellers",
    memberCoupon: {
      title: "New member offer",
      desc: "Register and get 10% off your first order",
      action: "Register now",
      shopAction: "Shop now",
    },
    tit0: {
      title: "Check availability here for free now",
    },
    tit1: {
      title: "Tailor-made transformer solutions up to 400 kV",
      text: "Whether distribution transformer, power transformer or special solution: We offer tailor-made transformers for medium and high voltage applications according to your grid requirements.",
      button: "Discover Transformer Products",
    },
    tit2: {
      title: "Optimized solutions for energy suppliers and large-scale projects",
      text: "Our production facilities in China enable high output—for example, up to 1,000 medium-voltage transformers per month. Combined with well-organized logistics, we offer competitive delivery times.",
      button: "Our Choice",
    },
    wsc_tit1: "Why You Should Choose Us",
    wsc_tit2: "Our Cooperation Partners",
    wsc_tit3: "Everyday Life with Renewable Energy",
    wsc_tit4: "Company Updates to Share with You",
    wsc_tit5: "More",
    wsc_sub1: "Our products meet the highest international quality and safety standards",
    wsc_sub2: "Trust in our strong partnerships with leading companies in the energy industry",
    wsc_sub3: "Stay informed about the latest developments and projects",
    services_title: "Our Services",
    services_sub: "Tailored solutions for your energy projects",
    readMore: "Read More",
    learnMore: "Learn More",
    box1: "Switchgear",
    box1_desc: "Efficient and SF₆-free high voltage switchgear.",
    box2: "Transformer",
    box2_desc: "Powerful transformers for high voltage networks.",
    box3: "Medium Voltage Cable",
    box3_desc: "Reliable connection solutions for energy distribution.",
  },
  banner: {
    title: "Supporting renewable energy",
  },
  footer: {
    p1: "Consultation hotline：",
    p2: "Contact",
    p3: "Germany",
    p5: 'Views',
    avis1: "Free Transport",
    avis2: "Payment Options",
    search: {
      tit: "Subscribe Now and Get in Touch!",
      button: "Subscribe",
      t1: "I agree to the",
      t2: " Terms of Use ",
      t3: "and",
      t4: "Privacy Policy",
    },
    navList: {
      name1: "about us",
      children1: {
        name1: "Team support",
      },
      name2: "Support",
      children2: {
        name2: "Our ecological charter",
      },
    },
  },
  pay: {
    item1: "Home",
    item2: "Product Center",
    item3: "Product information",
    item4: "Payment",
    label1: {
      title: "Contact information",
      text: "You already have an account?",
      el: "Sign In",
      input: "Please select an address",
      tip: "Please add address",
    },
    label2: {
      title: "Shipping address",
      input1: "Name",
      input2: "Other address information",
      input3: "Postal code",
      input4: "City",
      input5: "Telephone",
    },
    info: {
      pro_info: "Product information",
      type1: "DC Trans Logistik & Trade GmbH",
      type2: "Eisenstrasse 30, 65428 Rüsselsheim",
      type3: "Deutsche Postbank Ndl",
      span1: "Free shipping",
      span2: "Lifetime service",
      span3: "No questions asked.Manufacturer warranty",
    },
    button: "Checkout",
    products: {
      message_error: "Parameter error!",
    },
    validate: {
      message1: "Please select the delivery address",
      message2: "Please select the invoice address",
      message3: "Please agree to terms and conditions",
    },
    addOrder: {
      message_success: "Successful order",
      message_warning: "Add order failed",
    },
    notice:
      "Note: Please make sure that your name is pasted on your doorbell and if it has access control or needs to be forwarded to someone, otherwise it may not be delivered. For the safety of your parcel, please try to separate the items with fragile glass.",
    transfer: {
      text1:
        "Please transfer the invoice amount to our bank account. You will receive an order confirmation notification by email with your bank details and order number",
      text2: "money",
      text3: "Account owner name",
      text4: "Please include these details",
      text5: "Bank account number",
      text6: "Contact address of the payee",
      text7: "Bank name",
      text8: "Agree to terms and conditions",
      text9: "terms of service",
    },
    result: {
      text1: "Your payment has been completed successfully. Your order is being processed and prepared for shipment.",
      text2: "order number",
      text3: "pattern of payment",
      text4: "bank transfer",
      text5: "payment amount",
      fail_text: 'Payment failed. Please try again or choose a different payment method.',
      cancle_text: 'Payment was cancelled. Your order has not been completed.',
      loading_text: 'Confirming payment, please wait...',
    },
    button2: "Continue Shopping",
    button3: "View Orders",
    type: "transportation type",
    pay_info:
      "DHL Global Express Germany home delivery /Paket shop over 39 euros free delivery",
    pay_info_days: "2-4 working days",
    pay_way: "pay way",
    pay_type: "Pay by bank wire transfer",
    eur: "(Ab. 3999 €)",
    pay_desc:
      " By adding your bank account, you authorize Amazon to send instructions to your bank to debit your account. You also authorize your bank to debit your account according to those instructions. You can request arefund within 8 weeks of the debit date. The terms you agreed to with your bank apply.",
    pay_save: "Save for future purchases",
    pay_info_pay:
      "Your payment information is encrypted and secure.<br />Saving your payment method for future purchases will help you check out faster.",
    pay_more: "Learn more",
    add_bank: "Add bank account",
  },
  pay2: {
    freeShipping: 'Free Shipping',
    text1: 'Contact Details',
    text2: 'Delivery Method',
    text3: 'Payment Method',
    text4: 'Order Completion',
    text14: 'Select how you want your items to be delivered.',
    text15: 'Standard Shipping',
    text16: 'Delivery to',
    text17: 'FREE',
    text18: 'Default',
    text19: 'Guest',
    text20: 'No address details',
    text21: 'Please select an address',
    text5: "Delivery Address",
    text6: "Billing Address",
    text7: "Edit",
    text8: "Other Delivery Address",
    text9: "Delivery time 2-3 working days",
    text10: "Delivery with:",
    text11: 'You have not yet saved a delivery address',
    text12: 'Pickup Station',
    text13: 'Go to logistics station',
    btn1: "Continue",
    btn2: "Continue",
    btn3: 'Add Delivery Address',
    btn4: 'Select Delivery Address',
    btn5: 'Buy Now',
    tit1: 'My Data',
    tit2: 'Your Billing Address',
    tit3: 'Choose a Delivery Address?',
    tit4: 'Delivery Address',
    tit5: 'Select Payment Method?',
    tit6: 'Shopping Cart',
    option1: 'PayPal',
    option2: 'Credit Card',
    msg1: 'With PayPal you pay conveniently and securely. Once you have a PayPal account, you only pay with your email address and password. This is done after completing the order.',
    msg2: 'The outstanding invoice amount will be debited from your credit card account when your purchase is shipped. You enter your credit card details after completing the order.',
    msg3: 'Including VAT.',
    text22: 'Self-pickup',
    text23: 'Pick up your order directly from us',
    submitOrder: 'Would you like to complete this order?'
  },
  address: {
    txt: "Delivery addresses",
    p: "Note: Delivery addresses can be edited or added when completing the order.",
    button: "Add a new address",
    tag: "Standard",
    onEdit: "Edit",
    form: {
      name: "First Name",
      phone: "Phone Number",
      address: "Address",
      company: 'House Number/Apt/Company Name, C/O',
      street: 'Street',
      number: 'No.',
      number_tip: 'If there is no street number, replace with "-"',
      postal_code: "Postal Code",
      city: "City",
      country: "State",
      checkbox: "Set as default address",
      checkbox2: "The address is also used as billing address",
      onSubmit: "Add Address",
      default: 'Default',
    },
    rules: {
      message: "This field is required",
    },
    dialog_tiltle: "Add a new address",
    name: "address",
    shipping: "Add shipping address",
    bill: "bill address",
  },
  clause: {
    onClose: "Reject All",
    acceptAll: "Accept All",
    class1: "We Value Your Privacy",
    class2: "We use cookies to enhance your browsing experience, serve personalized content, and analyze site usage. By clicking \"Accept All\", you consent to our use of cookies. For more information, read our",
    class3: "",
    class4: "Cookie Policy",
    text4: "",
    class5: "Functional",
    class6: "Cookies for analytics and improving website performance and user experience.",
    class7: "Marketing",
    class8: "Cookies for personalized advertising on partner platforms.",
    onAccept: "Accept All",
    class10: "Manage Preferences",
    br2: "Cookie Policy",
    class11: "Imprint",
    msg1: "Cookie Settings",
    msg2: "Choose which cookies you would like to allow.",
    msg3: "Marketing",
    msg4: "Enables personalized advertising on partner platforms such as Google and social networks.",
    msg5: "Functional",
    msg6: "Enables analytics to improve website performance and user experience.",
    msg7: "You can withdraw your consent at any time via Cookie Settings. Without selection, only required cookies will be used.",
    msg8: "Confirm Selection",
    required: "Required",
    alwaysActive: "Always active",
  },
  order: {
    item1: "Front page",
    item2: "My order",
    tip: "Please upload the remittance certificate",
    upload1: "upload",
    remittance: "Remittance certificate:",
    wmsInfo: "Delivery number:",
    select: "Order status",
    produces: 'Product List',
    state: {
      label1: "Unpaid",
      label2: "Paid",
      label3: "Shipped",
      label4: "Completed",
    },
    refund: {
      title: "Apply refund",
      orderNo: "Order no",
      amount: "Refund amount",
      reason: "Refund reason",
      reasonPlaceholder: "Select or enter a reason",
      description: "Description",
      descriptionPlaceholder: "Add more details for the merchant",
      evidence: "Evidence image",
      upload: "Upload image",
      submit: "Submit request",
      reasonRequired: "Please select or enter a refund reason.",
      reasonMax: "Refund reason cannot exceed 255 characters.",
      reasons: {
        productIssue: "Product issue",
        wrongItem: "Wrong item",
        qualityProblem: "Quality problem",
        other: "Other",
        addressWrong: "Wrong shipping address",
        notAsDescribed: "Not as described",
        infoWrong: "Incorrect information",
        reorder: "Place a new order",
        damaged: "Item arrived damaged",
        delayedOther: "Not shipped on time or other reason",
      },
    },
  },
  product: {
    item1: "Home",
    item2: "Product Center",
    class: "SEARCH",
    info: "Register to get more discounts",
    label: "Internet connection",
    prefixPrice: "From ",
    suffixPrice: "",
    detail: {
      scrollTo1: "Pay",
      scrollTo2: "Specifications",
      item1: "Home",
      item2: "Product Center",
      label: "Specification",
      Menge: "Quantity",
      label1: "Shipping method",
      wsc_title1: "Description",
      wsc_title2: "Features",
      wsc_title3: "Technical details",
      class1: "Add to cart",
      class2: "Buy now",
      dowload_tit: "Download",
      dowload1: "Installation Manual",
      dowload2: "Other Documents",
      dowload3: "Manual",
      dowload4: "Quality Assurance Manual",
      dowload5: "Datasheet",
      message: "Add successfully",
      message2: "The product is already in the cart, no need to add it again",
      params: "Product Parameters",
      weight: "Weight",
      dimensions: "Dimensions",
      inStock: "In stock",
      outOfStock: "Out of stock",
      vat: "(incl. VAT)",
      downloadTitle: "Data Download",
      chooseLang: "Choose your language",
      global: "Global",
      fileName: "File name",
      fileLanguage: "Language",
      fileFormat: "Format",
      fileSize: "Size",
      fileUpdated: "Last updated",
      fileDownload: "Download",
      noDocs: "No documents found.",
    },
    checkOption: {
      label1: "Internet connection",
    },
  },
  news: {
    item1: "Home",
    item2: "News",
    item3: 'News And Trends',
    item4: 'News Detail',
    item5: 'Published Time',
    text1: 'OSS · News And Trends',
    text2: 'More',
    text3: 'Last Article',
    text4: 'Next Article'
  },
  shop: {
    item1: 'Home',
    item2: 'My Shopping Cart',
    tit1: "My Shopping Cart",
    tit2: "Items",
    button: "Place Order",
    tit3: 'Shipping Costs',
    tit4: 'Invoice Amount',
    tit5: 'Amount to be Paid',
    tit6: 'VAT and shipping not included',
    summary: 'Order Summary',
    subtotal: 'Subtotal',
    free: 'Free',
    pendingShipping: 'To be calculated',
    continue: 'Continue Shopping',
  },
  solution: {
    tit: "About us",
    tit1: "We are eager for the Oss Energy program to provide sustainable energy solutions that both protect the environment and meet the needs of our customers. With long experience and a committed team of experts, we aim to make the world a greener and cleaner place.",
    tit2: "Our services include the installation and provision of high quality solar power plants for both residential and commercial customers. We are tailored to the needs, to individual needs and needs. From early consultation to design and installation, to regular maintenance and monitoring, we will ensure that solar energy is used smoothly and efficiently.",
    tit3: "Our commitment to quality and sustainability is at the heart of our business plan. We work closely with our customers to ensure optimal operation and maximum efficiency of solar power plants. We all pride ourselves on bringing low cost energy and long-term savings to our customers.",
    wsc_title1: "Product Series",
    tit4: "We are eager for the Oss Energy program to provide sustainable energy solutions that both protect the environment and meet the needs of our customers. With long experience and a committed team of experts, we aim to make the world a greener and cleaner place.Please contact us now at +49 69 71585988 or click on Learn More.",
    btn: "Learn More",
    wsc_title2: " Our advantage",
    tit5: "Tongwei solar shingled modules adopt innovative shingled technology, which is stronger and more beautiful than traditional solar modules, and can also use solar energy more effectively, thereby improving power generation efficiency",
    wsc_title3: "Solution",
    tit6: "At oss energy, our focus is not only on the quality and performance of our products, but also on outstanding customer service. Our experienced team installs your plant to industry standards and provides comprehensive after-sales service to ensure long-term operation and maintenance. We focus on your needs and provide reliable solutions and technical support.",
    tit7: "Solution 1: You do not have a photovoltaic system yet",
    tit8: "We offer customized green energy solutions with high profitability and long-term warranty. Based on your individual power consumption, we design an economical energy plan to give you the fastest profit. Our high-quality products maximize your yield time.",
    tit9: "Solution 2: You already have a photovoltaic system but need a storage",
    tit10:
      "Our fast photovoltaic storage solution allows you to connect a battery storage system without renewed grid connection approval or dismantling the existing system. By using the FIT series of inverters, we achieve an efficient connection between battery and your existing photovoltaic system. You save time and improve your self-consumption rate with a rapid implementation of an efficient storage system.",
    wsc_title4: "Honors",
    tit11:
      "Tongwei photovoltaic modules have been added to the list of Tier-1 global modules selected by Bloomberg New Energy Finance from among the Top 10. (4th quarter 2022 and 1. Quarter 2023)",
    tit12:
      "SolaX has won the “Best Commercial Inverter” award at the UK Solar Power Portal Awards, the “Best Battery Energy Storage System” award at the Australian Intersolar Awards and the UK Top Inverter and Top Battery awards from the German EUPD Research",
    item1: "Tier-1 list",
    item2: "Top inverters in UK",
    item3: "Top-BESS in Australia",
    item4: "Top inverter and battery in UK and DE",
    item5: "ECS",
    wsc_title5: "Product Advantages",
    wsc_title6: "For Private Households",
    li1: "Capacity Range: We specialize in providing photovoltaic systems with a capacity between 6 and 30 kilowatt peak (kWp), ideal for the energy needs of private households.",
    li2: "Customized Solutions: Our tailored photovoltaic solutions integrate perfectly into individual energy needs and spatial conditions.",
    li3: "Efficient Installation: Our experts ensure a fast and uncomplicated installation that integrates seamlessly into the domestic environment.",
    li4: "Cost-Effectiveness and Subsidies: We support our customers in achieving maximum financial benefits, including energy cost savings and government subsidies.",
    li5: "Simple Maintenance: Our low-maintenance PV systems provide reliable and efficient energy supply.",
    li6: "Regulatory Compliance: We guarantee compliance with all local building codes and legal requirements.",
    wsc_title7: "For Commercial",
    li7: "Capacity Range: For businesses, we offer comprehensive PV solutions up to a capacity of 2 trillion kilowatt peak (kWp), designed for the high energy requirements of commercial and industrial operations.",
    li8: "Large-Scale PV Projects: Our systems are scalable and can be flexibly adapted to complex operational structures.",
    li9: "Advanced Energy Management Systems: We integrate PV systems into existing energy management structures, offering innovative solutions for energy generation, storage, and management.",
    li10: "Comprehensive Consulting and Compliance: Our experienced team navigates through complex regulatory landscapes to ensure compliance and operational efficiency.",
    li11: "Long-Term Investment Returns: We help businesses achieve long-term financial and ecological benefits.",
    li12: "Professional Maintenance and Monitoring: We provide advanced services to maximize the performance of PV systems.",
    bTitle1: 'OUR HOUSEHOLD PROJECTS',
    bTitle2: 'OUR COMMERCIAL PROJECTS',
    bTip: 'WE MAKE YOUR HOMES GREENER!',
    bTip2: 'WE MAKE YOUR BUSINESSES GREENER!'
  },

  login: {
    login_name: "Login",
    register_name: "Register",
    code: "Verification Code",
    login_tit: "Enjoy the best experience",
    tit: "Simply log in and track orders, adjust settings and enjoy exclusive offers.",
    tit1: "Please enter the registration information and login to view the discount information after registration",
    tit2: "Existing account, forgot password?",
    form: {
      name: "Name",
      namePlaceholder: "Enter your full name",
      email: "E-Mail",
      emailPlaceholder: "your-email@example.com",
      password: "Password",
      passwordPlaceholder: "Enter your password",
      createPasswordPlaceholder: "Create a strong password",
      confirmPassword: "Confirm password",
      confirmPasswordPlaceholder: "Repeat your password",
      code: "Verification code",
      codePlaceholder: "Enter code",
    },
    checkEmail: {
      tit1: "Email must not be empty",
      tit2: "Please enter your email address.",
    },
    validatePass2: {
      tit1: "Please enter the password again",
      tit2: "The passwords entered twice are inconsistent!",
    },
    password: {
      message: "The password contains 8 to 16 characters",
      tit: "Must not same as the username",
    },

    checkCode: {
      tit: "The verification code is empty",
    },
    content: "Please enter a combination of letters and numbers",
  },
  resetPwd: {
    name: "Reset Password",
    reset: "Reset",
    login: "Login",
    tit1: "Confirm Email",
    tit2: "Set Password",
    tit3: "Finish",
    next: "Next",
    prev: "Previous",
  },
  error: {
    page: "Page Not Found",
    return: "Return to previous page",
  },
  header: {
    menuList: {
      name1: "Top Seller",
      name2: "About Us",
      name3: "Energy Equipment",
      name4: "Online Shop",
      name5: "Contact",
      children1: {
        name1: "Housing",
      },
      children3: {
        name1: "Transformers",
        name2: "Switchgear",
        name3: "Medium Voltage Cable",
      },
    },
  },
  contact: {
    title: "Get in Touch with Us",
    messgage1:
      "We are happy to help you, give us a call or send us a message. We look forward to hearing from you!",
    messgage2:
      "I agree that this website stores the information I have submitted so that my request can be answered.",
    form: {
      title: "Send Us a Message",
      subtitle: "Fill out the form and we'll get back to you as soon as possible",
      label0: "Position",
      label1: "Company",
      label2: "Full Name",
      label3: "Email",
      label4: "Phone",
      label5: "Message",
      label6: "GDPR Consent",
      placeholder0: "e.g. Project Manager",
      placeholder1: "Your company name",
      placeholder2: "Your full name",
      placeholder3: "your.email@example.com",
      placeholder4: "+49 123 456 7890",
      placeholder5: "Tell us how we can help you...",
    },
    info: {
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Business Hours",
      workdays: "Monday - Friday",
      time: "9:00 AM - 6:00 PM",
    },
    button: "Send Message",
  },
  top3: {
    tit1: {
      title: 'X3 Hybrid Inverter',
      text: 'The SolaX X3 Hybrid Inverter, available in 5 kW to 15 kW variants, is characterized by its efficiency of up to 97.5% when charging and discharging. It offers 200% oversizing for PV systems and up to 110% AC overload output. With shadow tracking function, economic operation and support for powerful solar modules (up to 150% PV input), it efficiently stores energy from PV to battery. Safe with IP65 protection and surge protection, it offers intelligent technology for fast switching in under 10 milliseconds, compatibility with lithium-ion and lead-acid batteries, and fast load response (0.3 seconds).'
    },
    tit2: {
      title: 'SMART EV CHARGER',
      text: 'The SolaX Smart EV Charger offers advanced charging options for electric vehicles. Available in three models: X1-EVC-7.2K, X3-EVC-11K and X3-EVC-22K, it enables flexible charging options. The charger is user-friendly, with selectable plugs or sockets for easy installation and suitable for indoor and outdoor use. It offers intelligent load balancing control and allows setting timers to take advantage of peak and off-peak pricing. Three charging modes are available: Green Mode, which uses PV energy, Fast Mode for maximum charging speed and ECO Mode for a fixed power. Remote monitoring and control is done via a user-friendly app.'
    },
    tit3: {
      title: 'T30 Battery',
      text: 'The T30 Battery from SolaX, part of the Triple Power series, offers a state-of-the-art solution for solar energy storage. It is available in various capacities from 3.3 kWh to 17.6 kWh and is suitable for both low and high voltage installations. Its high storage capacity enables long-term storage of solar energy, reducing dependence on the grid. The battery uses advanced lithium iron phosphate technology for high energy density and longevity. In addition, the system is modular and expandable, so customers can add additional batteries as their storage needs increase. The user-friendly software enables easy monitoring and control of energy consumption.'
    }
  },
  airset: {
    breadcrumb: {
      home: 'Home',
      products: 'Product Center',
      current: 'RM AirSeT™'
    },
    hero: {
      title: 'RM AirSeT™',
      subtitle: 'SF6-free compact or extensible gas-insulated ring main unit for secondary distribution up to 24 kV / 630 A / 20 kA'
    },
    products: {
      title: 'Product Range',
      subtitle: 'Three variants for different application requirements',
      view3d: 'View 3D Model',
      p1: {
        name: 'RM AirSeT™ Compact',
        subtitle: 'Compact Solution',
        desc: 'Compact, pre-configured switchgear for standard ring main networks. Ideal for space constraints in urban areas.',
        specs: 'up to 24 kV | 630 A | 20 kA',
        badge: 'Space-Saving'
      },
      p2: {
        name: 'RM AirSeT™ Active Plus',
        subtitle: 'Extensible Variant',
        desc: 'Modular system with flexible expansion options. Perfect for growing energy needs and future expansion stages.',
        specs: 'up to 24 kV | 630 A | 20 kA',
        badge: 'Recommended'
      },
      p3: {
        name: 'RM AirSeT™ Digital',
        subtitle: 'Intelligent Version',
        desc: 'Fully digitalized switchgear with IoT sensors and EcoStruxure™ integration for smart grid applications.',
        specs: 'up to 24 kV | 630 A | 20 kA',
        badge: 'Smart Grid'
      }
    },
    overview: {
      badge: 'SF6-Free',
      title: 'Gas-Insulated Switchgear for Sustainable Power Distribution',
      desc: 'RM AirSeT™ is an environmentally friendly, SF6-free gas-insulated switchgear (GIS) from Schneider Electric. Using pure air as insulation medium, it offers a sustainable solution for medium voltage ring main networks. Designed to be compact or extensible, it is ideal for secondary power distribution in urban and industrial environments.',
      features: {
        f1: {
          title: '100% SF6-Free',
          desc: 'Pure air insulation, no harmful greenhouse gases'
        },
        f2: {
          title: 'Compact & Flexible',
          desc: 'Space-saving design, extensible as needed'
        },
        f3: {
          title: 'Ring Main Technology',
          desc: 'Reliable solution for secondary distribution networks'
        }
      }
    },
    model3d: {
      title: 'View 3D Model',
      description: 'Explore the RM AirSeT™ in an interactive 360° view',
      button: 'Open 3D Model'
    },
    merkmale: {
      title: 'Advantage',
      subtitle: 'Innovative technology for sustainable power distribution',
      m1: {
        title: 'Sustainability',
        desc: 'Pure air insulation medium - zero greenhouse gas emissions, GWP = 1',
        advantages: [
          'Air insulation + vacuum breaking (no F-gases)',
          'Zero global warming potential (no end-of-life costs)'
        ]
      },
      m2: {
        title: 'Safety',
        desc: 'Space-saving construction for urban environments and limited spaces',
        advantages: [
          'IP67 enclosure (ambient-proof insulation)',
          '3-position switch + SVI™ (toxin-free switching)',
        ]
      },
      m3: {
        title: 'Reliability',
        desc: 'Flexibly expandable according to future energy requirements',
        advantages: [
          '40-year quality (5M+ units installed)',
          'Sealed IP67 tank (maintenance-free for life)'
        ]
      },
      m4: {
        title: 'Flexibility',
        desc: 'Same safety standards as SF6 switchgear, fully tested',
        advantages: [
          '1-4 units in 1 enclosure (compact footprint)',
          'Customizable pre-wired kits (2 heights for switchgear/plinths)'
        ]
      },
      m5: {
        title: 'Connectivity',
        desc: 'Durable components, reduced operating costs over entire lifecycle',
        advantages: [
          'IT/OT integration (real-time monitoring)',
          '3D models + DMS link (predictive maintenance support)',
        ]
      },
      m6: {
        title: 'Digital Ready',
        desc: 'EcoStruxure™-compatible for intelligent energy management and remote monitoring',
        advantages: [
          'EcoStruxure™ integration',
          'IoT sensors available',
        ]
      }
    },
    benefits: {
      title: 'Your Benefits',
      subtitle: 'Sustainable, safe and future-proof',
      b1: {
        title: 'Climate Neutral',
        desc: 'Zero SF6 emissions, GWP = 1, meets F-Gas regulations and Green Deal objectives'
      },
      b2: {
        title: 'Proven Technology',
        desc: 'Tested air insulation technology with same safety level as SF6 switchgear'
      },
      b3: {
        title: 'Low Maintenance',
        desc: 'Durable design, reduced operating costs over the entire lifecycle'
      },
      b4: {
        title: 'Future-Proof',
        desc: 'Meets upcoming environmental regulations, no restrictions on use'
      }
    },
    applications: {
      title: 'Applications',
      subtitle: 'Versatile applications in medium voltage distribution',
      a1: {
        title: 'Residential & Commercial Buildings',
        desc: 'Power supply for residential complexes, office buildings and shopping centers'
      },
      a2: {
        title: 'Industry',
        desc: 'Power distribution for production facilities and manufacturing plants'
      },
      a3: {
        title: 'Critical Infrastructure',
        desc: 'Reliable supply for hospitals, data centers and public facilities'
      },
      a4: {
        title: 'Utilities',
        desc: 'Secondary distribution in ring main networks of utilities and network operators'
      },
      a5: {
        title: 'Renewable Energy',
        desc: 'Grid connection and distribution for solar and wind energy projects'
      },
      a6: {
        title: 'Transport & Traffic',
        desc: 'Power supply for train stations, subway systems and airports'
      }
    },
    specs: {
      title: 'Technical Specifications',
      subtitle: 'High-performance parameters for highest requirements',
      electrical: {
        title: 'Electrical Data',
        voltage: 'Rated Voltage',
        voltage_val: 'up to 24 kV',
        current: 'Rated Current',
        current_val: 'up to 630 A',
        shortCircuit: 'Short-circuit Rating',
        shortCircuit_val: 'up to 20 kA',
        insulation: 'Insulation Medium',
        insulation_val: 'Pure Air (SF6-free)'
      },
      environmental: {
        title: 'Environmental Data',
        gwp: 'Global Warming Potential (GWP)',
        gwp_val: '1 (Air)',
        temp: 'Operating Temperature',
        temp_val: '-5°C to +40°C',
        protection: 'Protection Rating',
        protection_val: 'IP2X / IP3X',
        altitude: 'Max. Operating Altitude',
        altitude_val: 'up to 1000 m ASL'
      },
      mechanical: {
        title: 'Mechanical Data',
        dimensions: 'Design',
        dimensions_val: 'Compact / Extensible',
        installation: 'Installation',
        installation_val: 'Indoor',
        lifespan: 'Lifetime',
        lifespan_val: '> 30 years',
        maintenance: 'Maintenance',
        maintenance_val: 'Low maintenance'
      }
    },
    features: {
      title: 'Digital Features',
      f1: {
        title: 'EcoStruxure™ Ready',
        desc: 'Fully compatible with the EcoStruxure™ platform for IoT-based energy management'
      },
      f2: {
        title: 'Intelligent Monitoring',
        desc: 'Optional sensors and measuring devices for condition monitoring and load management'
      },
      f3: {
        title: 'Digital Services',
        desc: 'Cloud-based analytics services for predictive maintenance and operational optimization'
      },
      f4: {
        title: 'Remote Access',
        desc: 'Secure remote diagnostics and configuration for maximum availability'
      }
    },
    cta: {
      title: 'The Future of Power Distribution is SF6-Free',
      desc: 'RM AirSeT™ combines proven switchgear technology with environmentally friendly innovation. Contact us for individual consultation on your sustainable medium voltage solution.',
      btn1: 'Request Consultation',
      btn2: 'Load Product Datasheet'
    }
  }
};
export default en;
